// import React, { useState } from "react";
// import {
//   Container,
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Paper,
//   Alert,
//   Stack
// } from "@mui/material";
// import { useNavigate, Link } from "react-router-dom";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";

// const ClientSignup = () => {

//   const navigate = useNavigate();

//   const [form,setForm] = useState({
//     legal_name:"",
//     business_email:"",
//     password:""
//   });

//   const [message,setMessage] = useState("");
//   const [error,setError] = useState("");

//   const handleChange = (e)=>{
//     setForm({...form,[e.target.name]:e.target.value});
//   };

//   const handleSubmit = async(e)=>{
//     e.preventDefault();

//     try{

//       const res = await ApiServices.post(
//         "/api/v1/clients/register/",
//         form
//       );

//       setMessage(res.data.message);

//       setTimeout(()=>{
//         navigate("/client-login");
//       },2000);

//     }catch(err){

//       const message =
//         err?.response?.data?.business_email?.[0] ||
//         "Registration failed";

//       setError(message);

//     }
//   };

//   return (
//     <Container maxWidth="sm">

//       <Box sx={{py:10}}>

//         <Paper sx={{p:4}}>

//           <Typography variant="h5" fontWeight={600} mb={3}>
//             Client Signup
//           </Typography>

//           {message && <Alert severity="success">{message}</Alert>}
//           {error && <Alert severity="error">{error}</Alert>}

//           <Box component="form" onSubmit={handleSubmit}>

//             <Stack spacing={2}>

//               <TextField
//                 label="Legal Business Name"
//                 name="legal_name"
//                 value={form.legal_name}
//                 onChange={handleChange}
//                 required
//               />

//               <TextField
//                 label="Business Email"
//                 name="business_email"
//                 value={form.business_email}
//                 onChange={handleChange}
//                 required
//               />

//               <TextField
//                 label="Password"
//                 type="password"
//                 name="password"
//                 value={form.password}
//                 onChange={handleChange}
//               />

//               <Button variant="contained" type="submit">
//                 Register
//               </Button>

//               <Typography fontSize={14} textAlign="center">

//                 Already have an account?

//                 <Link to="/client-login">
//                   Login
//                 </Link>

//               </Typography>

//             </Stack>

//           </Box>

//         </Paper>

//       </Box>

//     </Container>
//   );
// };

// export default ClientSignup;



import React, { useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  Stack,
  Grid,
  IconButton,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import logo from "../../../Assets/logo.png";

const accent = "#0d47a1";

const btnSx = {
  backgroundColor: accent,
  borderRadius: "12px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "1rem",
  py: 1.5,
  boxShadow: "0 4px 14px rgba(13,71,161,0.25)",
  transition: "all 0.25s ease",
  "&:hover": {
    backgroundColor: "#093170",
    transform: "translateY(-1px)",
    boxShadow: "0 6px 20px rgba(13,71,161,0.35)",
  },
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#f8f9fb",
    transition: "all 0.2s ease",
    "& fieldset": { borderColor: "#e0e0e0" },
    "&:hover fieldset": { borderColor: accent },
    "&.Mui-focused fieldset": { borderColor: accent, borderWidth: 2 },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent },
};

const ClientSignup = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    legal_name: "",
    business_email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError("");
      setMessage("");

      const res = await ApiServices.post("/api/v1/clients/register/", form);

      setMessage(res.data.message);

      setTimeout(() => {
        navigate("/client-login");
      }, 2000);
    } catch (err) {
      const message =
        err?.response?.data?.business_email?.[0] || "Registration failed";

      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Client Signup | Rite Marketing Automation Platform</title>
        <meta
          name="description"
          content="Create your Rite Marketing client account. Automate marketing, manage customers, accept orders & bookings, and grow your business with AI-powered tools."
        />
        <meta
          name="keywords"
          content="client signup, register, marketing automation, business tools, Rite Marketing"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <meta
          property="og:title"
          content="Client Signup | Rite Marketing Automation Platform"
        />
        <meta
          property="og:description"
          content="Register as a client and start automating your marketing with AI-powered tools."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <Box
        sx={{
          minHeight: "84vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #eef2f7 0%, #dce3ed 100%)",
          position: "relative",
          overflow: "hidden",
          py: 4,
        }}
      >
        {/* Background decorations */}
        <Box
          sx={{
            position: "absolute",
            width: 500,
            height: 500,
            borderRadius: "50%",
            background: `radial-gradient(circle, ${accent}10 0%, transparent 70%)`,
            top: -120,
            left: -100,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: 400,
            height: 400,
            borderRadius: "50%",
            background: `radial-gradient(circle, ${accent}08 0%, transparent 70%)`,
            bottom: -80,
            right: -60,
          }}
        />

        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Grid
            container
            spacing={6}
            alignItems="center"
            justifyContent="center"
          >
            {/* Branding Panel — desktop only */}
            <Grid
              item
              xs={12}
              md={5}
              sx={{ display: { xs: "none", md: "block" } }}
            >
              <Box sx={{ pr: 4 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 800,
                    color: accent,
                    lineHeight: 1.2,
                    mb: 1,
                  }}
                >
                  Rite Marketing
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 300, color: "#555", mb: 3 }}
                >
                  Automation Platform
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: "#777", lineHeight: 1.8, maxWidth: 380 }}
                >
                  Join thousands of businesses already automating their
                  marketing, managing customers, and growing revenue with our
                  AI-powered tools.
                </Typography>

                <Stack spacing={1.5} sx={{ mt: 4 }}>
                  {[
                    "AI-powered campaign automation",
                    "Order & booking management",
                    "Real-time analytics dashboard",
                    "Dedicated account support",
                  ].map((item) => (
                    <Box
                      key={item}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: accent,
                          flexShrink: 0,
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "#666" }}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Box>
            </Grid>

            {/* Signup Card */}
            <Grid item xs={12} md={5}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3.5, sm: 5 },
                  borderRadius: "20px",
                  border: "1px solid #e4e8ee",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.06)",
                  maxWidth: 440,
                  mx: "auto",
                }}
              >
                <Box sx={{ textAlign: "center", mb: 4 }}>
                  <Box
                    component="img"
                    src={logo}
                    alt="Rite Marketing Logo"
                    sx={{ height: 60, mb: 2, borderRadius: "12px" }}
                  />
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, color: "#1a1a1a", mb: 0.5 }}
                  >
                    Create Your Account
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#999" }}>
                    Get started in just a few steps
                  </Typography>
                </Box>

                {message && (
                  <Alert
                    severity="success"
                    onClose={() => setMessage("")}
                    sx={{ mb: 2.5, borderRadius: "10px" }}
                  >
                    {message}
                  </Alert>
                )}

                {error && (
                  <Alert
                    severity="error"
                    onClose={() => setError("")}
                    sx={{ mb: 2.5, borderRadius: "10px" }}
                  >
                    {error}
                  </Alert>
                )}

                <Box component="form" onSubmit={handleSubmit}>
                  <Stack spacing={2.5}>
                    <TextField
                      fullWidth
                      label="Legal Business Name"
                      name="legal_name"
                      value={form.legal_name}
                      onChange={handleChange}
                      required
                      sx={inputSx}
                    />

                    <TextField
                      fullWidth
                      label="Business Email"
                      name="business_email"
                      type="email"
                      value={form.business_email}
                      onChange={handleChange}
                      required
                      sx={inputSx}
                    />

                    <TextField
                      fullWidth
                      label="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={form.password}
                      onChange={handleChange}
                      required
                      sx={inputSx}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      disableElevation
                      disabled={loading}
                      sx={btnSx}
                    >
                      {loading ? (
                        <CircularProgress size={24} sx={{ color: "#fff" }} />
                      ) : (
                        "Create Account"
                      )}
                    </Button>

                    <Typography
                      fontSize={14}
                      textAlign="center"
                      sx={{ color: "#888" }}
                    >
                      Already have an account?{" "}
                      <Link
                        to="/client-login"
                        style={{
                          color: accent,
                          fontWeight: 600,
                          textDecoration: "none",
                        }}
                      >
                        Login
                      </Link>
                    </Typography>
                  </Stack>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ClientSignup;
